import { Box, Text, Flex } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import {
  AssignmentSummaryAccordion,
  AssignmentSummaryAccordionRow,
} from './SharedComponents';
import type { PortfolioStat } from './SharedComponents';
import { colors } from 'packages/common-frontend/colors';

export const BorrowingBaseFromReceivables: React.FC<{
  initial: PortfolioStat;
  proposed: PortfolioStat;
  creditAgreement: CreditAgreement.DomainEntity.CreditAgreementFullArtifact;
}> = ({ initial, proposed, creditAgreement }) => {
  const {
    borrowingBaseMechanics: {
      calcAgentMechanics: { loanProductMechanics },
    },
  } = creditAgreement;
  return (
    <Box mt="24px">
      <Flex
        borderBottom="1px solid"
        borderColor={colors.gray[200]}
        p="8px 0px 8px"
        mb="16px"
      >
        <Text fontWeight="bold">Borrowing Base from Receivables</Text>
      </Flex>
      <AssignmentSummaryAccordion
        accordionButton={({ hasAccordionPanel, isExpanded }) => (
          <AssignmentSummaryAccordionRow
            label="Total Borrowing Base from Receivables"
            calcTerminologiesLabel="Total Receivable Borrowing Base Amount"
            initialValue={initial.totalBorrowingBaseAmount}
            proposedValue={proposed.totalBorrowingBaseAmount}
            valueType="currency"
            hasAccordionPanel={hasAccordionPanel}
            isExpanded={isExpanded}
            fullRowBackground
            background="medium"
          />
        )}
        accordionPanel={
          <Box>
            {_.map(loanProductMechanics, (loanProduct) => {
              return (
                <Box
                  mt="8px"
                  key={`loan-product-borrowing-base-amount-${loanProduct.entity.id}`}
                >
                  <AssignmentSummaryAccordionRow
                    subLabel={loanProduct.entity.name}
                    initialValue={
                      initial.totalBorrowingBaseAmountByLoanProductId[
                        loanProduct.entity.id
                      ]
                    }
                    proposedValue={
                      proposed.totalBorrowingBaseAmountByLoanProductId[
                        loanProduct.entity.id
                      ]
                    }
                    valueType="currency"
                    fullRowBackground
                    background="light"
                  />
                </Box>
              );
            })}
          </Box>
        }
      />
      <Box mt="8px">
        <AssignmentSummaryAccordion
          accordionButton={({ hasAccordionPanel, isExpanded }) => (
            <AssignmentSummaryAccordionRow
              label="Effective Receivable Advance Rate"
              calcTerminologiesLabel="Effective Receivable Advance Rate"
              initialValue={initial.effectiveReceivableAdvanceRate}
              proposedValue={proposed.effectiveReceivableAdvanceRate}
              valueType="percentage"
              hasAccordionPanel={hasAccordionPanel}
              isExpanded={isExpanded}
              fullRowBackground
              background="medium"
            />
          )}
          accordionPanel={
            <Box>
              {_.map(loanProductMechanics, (loanProduct) => {
                return (
                  <Box
                    mt="8px"
                    key={`loan-product-effective-receivable-advance-rate-${loanProduct.entity.id}`}
                  >
                    <AssignmentSummaryAccordionRow
                      subLabel={loanProduct.entity.name}
                      initialValue={
                        initial.effectiveReceivableAdvanceRateByLoanProductId[
                          loanProduct.entity.id
                        ]
                      }
                      proposedValue={
                        proposed.effectiveReceivableAdvanceRateByLoanProductId[
                          loanProduct.entity.id
                        ]
                      }
                      valueType="percentage"
                      fullRowBackground
                      background="light"
                    />
                  </Box>
                );
              })}
            </Box>
          }
        />
      </Box>
    </Box>
  );
};
